import React, { useState } from "react";
import "./Testimonial.css";

const testimonials = [
  {
    quote: "I've been to several hospitals affiliated with ABC Healthcare Solutions, and I must say, the facilities they provide truly set a high standard in healthcare. From well-maintained facilities to efficient medical staff, every aspect of their service is geared towards patient comfort and satisfaction. I'm grateful for their dedication to providing top-notch healthcare experiences.",
    name: "Rabindra Sapkota",
    title: ""
  },
  {
    quote: "ABC Healthcare Solutions Air Ambulance service provided me with exceptional care and professionalism during my medical transport. From the moment I contacted them, their professionalism was evident in their efficient document processing. The medical team onboard was exceptional, providing expert care with well-equipped medical instruments. I felt reassured and comfortable throughout the journey, knowing I was in capable hands. I highly recommend ABC Healthcare Solutions for their top-notch service and dedication to patient care.",
    name: "Anil Maharjan",
    title: ""
  },
  {
    quote:" ABC Healthcare Solutions facilitated my kidney transplant in India with utmost professionalism and care. Their team ensured seamless coordination, top-notch medical expertise, and personalized attention throughout the process. Thanks to them, I received world-class treatment and am now on the road to recovery. Highly recommend their services for anyone seeking medical care abroad.”",
    name: "Yasis Chand Thakuri",
    title: ""
  },
  {
    quote:"ABC Healthcare Solutions made accessing general OPD services incredibly easy with their streamlined document process. Their efficiency and attention to detail ensured a hassle-free experience from start to finish. I'm grateful for their assistance in navigating the healthcare system, making my visit to the doctor stress-free and efficient",
    name: "Sugam Sapkota",
    title: ""
  }

];

const Testimonial = () => {
  const [index, setIndex] = useState(0);

  const prev = () => setIndex((index - 1 + testimonials.length) % testimonials.length);
  const next = () => setIndex((index + 1) % testimonials.length);

  return (
    <div className="testimonial-container">
      <h2>Don’t take our word for it. Take theirs</h2>
      <p className="quote">“{testimonials[index].quote}“</p>
      <p className="name">{testimonials[index].name}</p>
      <p className="title">{testimonials[index].title}</p>

      <div className="controls">
        <button onClick={prev}>&lt;</button>
        <div className="dots">
          {testimonials.map((_, i) => (
            <span key={i} className={`dot ${i === index ? "active" : ""}`} />
          ))}
        </div>
        <button onClick={next}>&gt;</button>
      </div>
    </div>
  );
};

export default Testimonial;
